import { ThemeEvents } from '@theme/events';

const BaseElement = globalThis.HTMLElement || class {};

export class ProductVariantSku extends BaseElement {
  connectedCallback() {
    if (this.controller) return;
    this.row = this.querySelector('[data-product-sku-row]');
    this.value = this.querySelector('[data-product-sku-value]');
    this.availability = this.querySelector('[data-product-availability]');
    if (!this.row || !this.value) return;
    try {
      this.variantIds = new Set(JSON.parse(this.dataset.variantIds).map(String));
    } catch {
      this.hideSku();
      return;
    }
    this.section = this.closest('.shopify-section, dialog');
    this.controller = new AbortController();
    const listenerOptions = { signal: this.controller.signal };
    this.onVariantSelected = (event) => {
      const picker = event.target?.closest?.('variant-picker[data-product-id]');
      if (String(picker?.dataset.productId) !== this.dataset.productId) return;
      this.pendingOptions = Array.from(picker.querySelectorAll('select option[selected], fieldset input:checked')).map((option) => option.value);
      this.hideSku();
    };
    this.onVariantUpdate = (event) => {
      if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
      const variant = event.detail.resource;
      if (this.pendingOptions && variant) {
        if (!Array.isArray(variant.options) || variant.options.length !== this.pendingOptions.length || variant.options.some((option, index) => option !== this.pendingOptions[index])) return;
      }
      this.pendingOptions = null;
      if (!variant || !this.variantIds.has(String(variant.id))) {
        this.hideSku();
        return;
      }
      this.updateAvailability(event.detail.data.html);
      if (typeof variant.sku !== 'string' || !variant.sku.trim()) {
        this.hideSku();
        return;
      }
      this.value.textContent = variant.sku;
      this.row.hidden = false;
    };
    this.section?.addEventListener(ThemeEvents.variantSelected, this.onVariantSelected, listenerOptions);
    this.section?.addEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate, listenerOptions);
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
  }

  hideSku() {
    this.value.textContent = '';
    this.row.hidden = true;
  }

  updateAvailability(html) {
    if (!this.availability || typeof html?.querySelectorAll !== 'function') return;
    const component = Array.from(html.querySelectorAll('product-variant-sku[data-product-id]'))
      .find((element) => element.dataset.productId === this.dataset.productId);
    const availability = component?.querySelector('[data-product-availability]');
    if (typeof availability?.textContent !== 'string' || !availability.textContent.trim()) return;
    this.availability.textContent = availability.textContent.trim();
  }
}

if (globalThis.customElements && !customElements.get('product-variant-sku')) customElements.define('product-variant-sku', ProductVariantSku);
